// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2xFxv","name":"ConsentHeader_name__3pYWw","birthday":"ConsentHeader_birthday__2WDaZ","skeleton":"ConsentHeader_skeleton__kgZuQ"};